import { render, staticRenderFns } from "./complaintRecord.vue?vue&type=template&id=eaaf6ae6&scoped=true"
import script from "./complaintRecord.vue?vue&type=script&lang=js"
export * from "./complaintRecord.vue?vue&type=script&lang=js"
import style0 from "./complaintRecord.vue?vue&type=style&index=0&id=eaaf6ae6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaaf6ae6",
  null
  
)

export default component.exports